export function generateDictionaries(fields: any[]): { [key: string]: { [key: string]: string } } {
    const dictionaries: { [key: string]: { [key: string]: string } } = {};

    fields.forEach(field => {
        if (field.domain && field.domain.codedValues) {
            const fieldDict: { [key: string]: string } = {};
            field.domain.codedValues.forEach((codedValue: { code: string | number, name: string }) => {
                fieldDict[codedValue.code] = codedValue.name;
            });
            dictionaries[field.name] = fieldDict;
        }
    });

    return dictionaries;
}

export const getNameByCode = (dictionary: { name: string; code: number }[], code: number): string => {
    const item = dictionary.find(item => item.code === code);
    return item ? item.name : "";
};